import { makeEntrance } from "./entrance";
import { GlassCard } from "./glass-card";
import { Glyph } from "./glyph";
import { usePrefersReducedMotion } from "./use-prefers-reduced-motion";

const ARROW_ICON = "M5 12h14m0 0-7-7m7 7-7 7";
const STEP_INTERVAL = 0.34;

export type StepCard = {
  /** 24×24 stroked path for the 28px card icon. */
  icon: string;
  title: string;
  sub: string;
};

/**
 * A row of glass cards joined by arrows, each card materialising in turn. Stacks
 * vertically below md. Shared by the Sample Requests and Smart Collab Groups
 * empty states.
 */
export function StepCardsRow({ steps }: { steps: StepCard[] }) {
  const reduceMotion = usePrefersReducedMotion();
  const entrance = makeEntrance(reduceMotion);

  return (
    <div className="flex w-full max-w-[1060px] flex-col items-start gap-6 md:flex-row md:items-stretch md:justify-start md:gap-4">
      {steps.map((step, index) => {
        const cardDelay = 0.35 + index * STEP_INTERVAL;
        const arrowDelay = 0.55 + index * STEP_INTERVAL;
        return (
          <div key={step.title} className="contents">
            <div className="flex w-full max-w-[320px] md:max-w-none md:flex-1">
              <GlassCard
                radius="2xl"
                className="flex w-full flex-col gap-3 p-6 backdrop-blur-3xl"
                style={{ animation: entrance.glassIn(cardDelay) }}
                overlayStyle={{ animation: entrance.fadeIn(cardDelay) }}
              >
                <div className="flex flex-col gap-3" style={{ animation: entrance.fadeInUp(cardDelay) }}>
                  <div aria-hidden="true" className="text-brand-200">
                    <Glyph d={step.icon} size={28} />
                  </div>
                  <div className="flex flex-col gap-1">
                    <p className="text-base font-semibold text-white">{step.title}</p>
                    <p className="text-sm text-brand-100">{step.sub}</p>
                  </div>
                </div>
              </GlassCard>
            </div>
            {index < steps.length - 1 && (
              <div
                aria-hidden="true"
                className="hidden shrink-0 self-center text-white/40 md:block"
                style={{ animation: reduceMotion ? undefined : `fade-in-up 0.4s ease-out ${arrowDelay}s both` }}
              >
                <Glyph d={ARROW_ICON} size={20} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
